const fractionMap = {
    0.1: '⅒',
    0.125: '⅛',
    0.25: '¼',
    0.3: '⅓',
    0.5: '½',
    0.6: '⅔',
    0.75: '¾',
};

// function to convert numbers with decimals to numbers with fractions
// e.g. 1.5 > 1 ½

export default function withFraction(number) {
    const decimalPart = (number % 1).toFixed(number.toString().split('.')[1]?.length);
    const fraction = fractionMap[decimalPart];
  
    if (fraction) {
      const wholeNumber = Math.floor(number);
      return wholeNumber ? `${wholeNumber} ${fraction}` : fraction;
    } else {
      return number;
    }
  }